import { ButtonBase, Tooltip, Typography } from "@mui/material";
import { Popover } from "antd";
import { useEffect, useState } from "react";

const InHouseSwitchBox = (props) => {
const {title,tabs,info,val,disb} = props;
const [tabIdx,setTabIdx] = useState(val);
let tootipText = '';
const handleSwitch = (idx,tabId) => {
    // if(props.settingsHandle){
    //     props.settingsHandle(idx,title.toLowerCase(),tabId);
    // }
    if (props.settingsHandle) {
      let titleName =  title.toLowerCase();
      if(titleName=='category'){
        titleName = 'type';
      }else if(titleName=='type'){
        titleName = 'category';
      }
      props.settingsHandle(idx,titleName, tabId);
    }
}
useEffect(()=>{
    setTabIdx(val);
},[val])
useEffect(()=>{
    setTabIdx(tabs[0].id);
},[tabs])
  return (
    <div className={`switch_tab mr-[20px] mb-[15px] inline-block`}>
        <label className="text-[13px] text-[#878B91] mb-[10px] inline-flex items-center">
            {title && title}
            {
                info && 
                <Popover content={tootipText}>
                    <img src="/images/fi_info.svg" alt="info" className="inline-block ml-[8px] cursor-pointer"/>
                </Popover>
            }
        </label>
          {/* {console.log("INDIE SWITCH", tabs, tabIdx)} */}
        <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex">
            {
                tabs.map((tab,idx)=>{
                    return(
                        <ButtonBase key={idx} disabled={(tab?.disabled || disb) ? true : false }>
                         <span className={`switch ${val == tab.id && 'active'}`} onClick={()=>handleSwitch(idx,tab.id)} >{tab.name}</span>
                        </ButtonBase>
                    )
                })
            }
        </div>
    </div>
  )
};

export default InHouseSwitchBox;
